<template>
  <PageSecondary class="burnout">
    <template #title>Самомассаж Сердца при Выгорании</template>
    <h4>Предыстория</h4>
    <span>
      Догадки о том, что я близок к выгоранию появились уже спустя пол года жизни в Америке в начале 2019ого года. Тогда
      я и ещё 3 партнёра начали строить стартап Newcrom. Мысли, что отдых и отпуск важен, точно были. Действия и поиски были.
    </span>
    <span>
      Маловато старался. Потому что месяц назад (Окт 2021) звезды, осень, усталость и обстоятельства сошлись так, что я
      открывал макбук и разум помутнялся. Всегда работавшие приёмы: поднатужиться, потупить пару часов, ванная, кофеёк,
      сладкое - не смогли сорвать плотную занавеску, за которой спрятался мой доёбанный в конец мозг.
    </span>
    <img src="@/assets/handdrawn/anxiety.jpg">
    <span>
      Спасибо моему другу Жене за тёплый разговор и подаренную книгу «Выгорание», причём это произошло ещё до полного
      дна. Мы обсуждали, что я не могу уйти в отпуск и не готов что-то менять. Чаще всего, люди меняют
      привычное только когда оно перестаёт работать. Наконец я сломался и ясно увидел: "я больше не работаю".
      Перемены стали неизбежны.
    </span>
    <Definition>
      <template #for>Нагоски "Выгорание"</template>
      Книга начинается с описания взаимосвязи между выгоранием и неэффективными шаблонами реакции на стресс.
      Разделяются 2 понятия - стрессор и стресс. Первое - причина (дедлайны), второе последствия (гормоны в теле).
      Разбираться необходимо с обоими и по-разному, в первую очеред с последствиями, именно
      они причина нерабочего состояния в моменте. От стресса помогает спорт и безопасная социализация.
      После снижения накала последствий хронического стресса - нужно перестраивать отношения
      со стрессорами или избавляться от них.
    </Definition>
    <h4>В запросе половина ответа</h4>
    <span>
      Важно было сформулировать и утвердить задачу: «выйти из выгорания как можно быстрее и без ухода в отпуск».
      Четкая формулировка дала понять, что решение моей задачи куда сложнее, чем обычная изоляция от стрессоров:
      «возьмите месяц-два отпуска или вообще саббатикл на пол года». Предыдущие годы меня шатало без запроса, я тратил
      время на откладывание мер, откладывание отпуска, думал «через пару месяцев возьму неделю отпуска и решится вопрос».
    </span>
    <img src="@/assets/handdrawn/fuck-off.jpg">
    <h4>Начало</h4>
    <span>
      Пришёл инсайт, что Инстаграм - один из источников подсознательного стресса, чужие жизни заставляют ощущать FOMO,
      чужие успехи - чуствовать себя отстающим, а в инстаграме всегда можно найти кому и чему позавидовать.
      Меня зарядило гневом, я удалил Инстаграм.
      Стало радостно, один из крантиков подливающих кортизол с адреналином перекрыт за 10 минут!
      Затем я побегал по улице и облился контрастным душем.
      </span>
    <Definition>
      <template #for>FOMO (Fear Of Missing Out)</template>
      Страх пропустить важное
    </Definition>
    <span>
      Переломной точкой стала мини-випассана на 2 дня.
      Я запер всю технику в ящик, дал обет молчания, запретил себе делать любые дела в выходные.
      За время наедине с собой я немножко «проснулся» от зомби-тормоза. Я начал вспоминать, что есть жизнь без мыслей!
    </span>
    <Definition>
      <template #for>Випасса́на (санскр. проникновенное видение) по Гоенке</template>
      вид медитации созерцания постоянно меняющейся природы ума и тела.
      Начинается с наблюдения за естественным (то есть неконтролируемым) дыханием, которое позволяет уму
      сконцентрироваться. Затем наблюдаются все виды телесных ощущений. По отношению к ним развивется осознанность и
      уравновешенность. Так постепенно приходит осознание взаимосвязи между умом и телом. Это важно т.к. позволяет
      внимательно слышать себя, замечать усталость и эмоции своевременно.
    </Definition>
    <span>
      Спустя месяц я накопил конкретные шаги, которые стоит сделать при выгорании, если нет возможности полностью
      изолироваться от образа жизни который истощает (взять длительный отпуск и переехать в страну чудес или Бали).
    </span>
    <img src="@/assets/handdrawn/bali-wave.jpg">
    <h4>Рецепт Реанимации</h4>
    Спорт
    <ul>
      <li>
        Каждый день минимум 10 минут интенсивной физ нагрузки - бег, приседания, отжимания. Важно чтобы пульс и
        дыхание существенно участились и пришла усталость, был момент «не могу больше, но сделаю ещё пару раз».
      </li>
      <li>
        2 раза в неделю часовая тренировка с тренером. Тренер позволяет отключить мысли полностью тк за тебя решает, что
        ты делаешь.
      </li>
      <li>Каждый день перед сном растяжка 10 минут.</li>
      <li>Каждый день перед сном контрастный душ через не могу.</li>
    </ul>
    Питание, добавки
    <ul>
      <li>Только вода, соки и травяной чай, никакого кофеина, чая, можно какао.</li>
      <li>3мг мелатонина в 9:20 вечера и отбой в 9:30.</li>
      <li>50мг 5-HTP утром (для серотонина)</li>
      <li>Я лопаю ещё бифидобактерии, и травы, они опционально (Ashwagandha, CoQ10, Ginkgo Biloba, Pau D'Arco, Cats
        Claw).
      </li>
    </ul>
    Сон, свет
    <ul>
      <li>Днём с самого утра включать весь яркий свет.</li>
      <li>Выключать яркий свет после 7:30 вечера.</li>
      <li>Спать в полной темноте. Либо шторы, либо повязка на глаза.</li>
      <li>Оставаться в кровати до состояния выспавшегося кота, нежущегося в одеяле.</li>
    </ul>
    Зоны
    <ul>
      <li>
        Для удалёнщиков. Физически в пространстве создать зону для работы и зону для интернета. Решать рабочие вопросы
        только в рабочей зоне.
      </li>
      <li>
        Если хочется поработать вне дома - заранее решить где и как долго. Не смешивать еду и работу,
        кушать в другом месте и другое время.
      </li>
      <li>
        Мысли о работе вне зоны работы отслеживаются и останавливаются установкой «я больше, чем моя работа, я подумаю
        об этом на рабочем месте»
      </li>
    </ul>
    <img src="@/assets/handdrawn/no.jpg">
    <span>Отпуск</span>
    <ul>
      <li>
        Суббота и воскресенье это дни без телефона и ноутбука вообще.
      </li>
      <li>
        Разумеется, без посещения зоны для работы.
      </li>
      <li>
        Всё необходимое для жизни в выходные необходимо подготовить в будни. Закупить еду, спланировать отдых. Убраться
        заранее! Сделать стирку заранее в будни!
      </li>
      <li>
        Я добавляю обет молчания на выходные, но не очень строго, иногда пою
        что-то. Иногда вижусь с друзьями и мычу им в ответ.
      </li>
    </ul>
    Общение
    <ul>
      <li>
        Я больше не общаюсь ни с кем долгое время в переписке, обрываю и планирую созвон или встречу.
        Проверка чатов и почты 2-5 раз в день. Никаких переписок после 8 вечера.
      </li>
      <li>
        Никакого интернета и работы пока не позавтракал и не сделал утреннюю зарядку с медитацией.
      </li>
    </ul>
    <h4>Внимание, Ловушка</h4>
    <span>
      Через пару недель возвращаешься на старые привычные рельсы и острая необходимость продолжать перемены и придерживаться
      реанимационного списка отпадает. В этот момент начинаются "кофейку немножно", "кино до часу ночи", "пропущу пробежку". Готовься
      вернуться обратно на прежнее дно, если будешь потакать старой колее. Помни, что опыт днища выгорания был дан,
      чтобы найти новую жизнь.
    </span>
    <img src="@/assets/handdrawn/forest-fire.jpg">
    <h4>После плато</h4>
    <span>
      Рецепт работает для реанимации и возвращения к жизни и работе.
      Мне этого мало, я хочу перестроить себя и жизнь так, что не буду критически зависеть от режима.
      Дальнейшие шаги:
    </span>
    <ul>
      <li>
        Исследование и переосознание ценностей;
      </li>
      <li>
        Планирование новой жизни, соответствующей ценностям;
      </li>
      <li>
        Методичное следование плану и вышеизложенному рецепту.
      </li>
    </ul>
    <span>
      Я на удивление благодарен тому дну, что я преодолел. Не потрогав его, я так и бежал бы в колесе, возможно всю жизнь.
      С радостью поделюсь опытом лично, если есть вопросы или сложности с состоянием выгорания.
    </span>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
import Definition from "@/components/blocks/Definition";

export default {
  name: "Past",
  components: {Definition, PageSecondary}
}
</script>

<style lang="scss" scoped>
.burnout {
  span {
    display: block;
    margin-top: 24px;
  }

  img {
    width: 100%;
    margin-top: 24px;
  }

  h4 {
    margin-top: 40px;
  }
}

.definition {

}
</style>
